import React, { useState } from "react";
import { Send, HelpCircle, MessageSquare } from "lucide-react";
import "./FeedbackPage.css";
import { feedbackApi } from "../../api/client";
import { getApiErrorMessage } from "../../api/http";

const FeedbackPage = () => {
  const [category, setCategory] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      await feedbackApi.create({ category, message });
      setSuccess("Feedback submitted successfully.");
      setCategory("");
      setMessage("");
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to submit feedback"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="feedback-wrapper bg-light-subtle min-vh-100">
      <div className="container py-5 pt-md-5">
        <div className="row align-items-center g-5">
          <div className="col-lg-5">
            <span className="badge-support mb-3 d-inline-flex align-items-center gap-2">
              <MessageSquare size={14} /> SUPPORT CENTER
            </span>
            <h1 className="display-4 fw-bold text-dark mb-4">How can we help?</h1>
            <p className="text-secondary lead mb-5">
              We value your input. Let us know about technical issues, content suggestions,
              or just share your general thoughts to help us improve the platform.
            </p>

            <div className="card common-questions-card border-0 shadow-sm p-4">
              <div className="d-flex align-items-center gap-2 mb-3">
                <HelpCircle className="text-primary-ieee" size={20} />
                <h6 className="fw-bold mb-0">Common Questions</h6>
              </div>
              <ul className="list-unstyled mb-0">
                <li className="mb-2"><button type="button" className="btn btn-link p-0 text-muted text-decoration-none small hover-link">How do I reset my password?</button></li>
                <li><button type="button" className="btn btn-link p-0 text-muted text-decoration-none small hover-link">Where can I find my transcripts?</button></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="card report-card border-0 shadow-lg p-4 p-md-5">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="fw-bold h4 mb-0">Submit a Report</h2>
                <span className="text-muted extra-small">* Required fields</span>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label className="form-label fw-bold small">Category <span className="text-primary">*</span></label>
                  <select className="form-select custom-input py-2" value={category} onChange={(e) => setCategory(e.target.value)} required>
                    <option value="" disabled>Select a category...</option>
                    <option value="Technical Issue">Technical Issue</option>
                    <option value="Content Suggestion">Content Suggestion</option>
                    <option value="General Feedback">General Feedback</option>
                  </select>
                </div>

                <div className="mb-4">
                  <label className="form-label fw-bold small">Your Message <span className="text-primary">*</span></label>
                  <textarea
                    className="form-control custom-input"
                    rows="5"
                    placeholder="Describe your issue or suggestion in detail. If reporting a bug, please include steps to reproduce it..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    required
                  ></textarea>
                </div>

                {error ? <div className="alert alert-danger py-2 small">{error}</div> : null}
                {success ? <div className="alert alert-success py-2 small">{success}</div> : null}

                <div className="d-flex justify-content-end align-items-center gap-4 mt-5">
                  <button type="button" className="btn btn-link text-muted text-decoration-none fw-bold small" onClick={() => { setCategory(""); setMessage(""); }}>
                    Cancel
                  </button>
                  <button disabled={loading} type="submit" className="btn btn-primary-ieee px-4 py-2 rounded-pill d-flex align-items-center gap-2">
                    <Send size={18} /> {loading ? "Submitting..." : "Submit Feedback"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;
